export const DEFAULT_HEARTBEAT_MESSAGE: string = "-heartbeat-city-";